import { Alert, AlertDescription, AlertIcon, Box } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export const OriginProcurementCancelledNotice = ({
  isCallOff,
  canDiscardDraft,
  action,
}: {
  isCallOff: boolean;
  canDiscardDraft: boolean;
  action?: ReactNode;
}) => {
  const { t } = useTranslation();
  return (
    <Alert status="warning" rounded="md" mt="4" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <Box>
        <AlertDescription>
          {isCallOff
            ? t("The procurement this draft came from is cancelled, so the call-off can't be completed.")
            : t("The procurement this draft came from is cancelled, so the contract can't be completed.")}
          {canDiscardDraft && <> {t("You can delete the draft.")}</>}
        </AlertDescription>
        {action}
      </Box>
    </Alert>
  );
};
